<template>
  <div>
    <div v-if="!haveToken && domains.length == 0" class="login-container">
      <div class="login-card">
        <!-- Logo and Welcome Section -->
        <div class="login-header">
          <img src="@/assets/iPosCafe-Logo.png" class="login-logo" alt="iPOS Cafe by Newcare International" />
          <!-- <h2 class="app-title">iPOS Cafe</h2> -->
          <!-- <p class="welcome-subtitle">Point of Sale </p> -->
        </div>

        <!-- Login Form Section -->
        <div class="login-body">
          <h3 class="login-title">Welcome Back</h3>
          <p class="login-subtitle">Sign in with your iCare account to continue</p>

          <div class="login-form">
            <div class="form-group">
              <label for="email" class="form-label">
                <i class="fa fa-envelope"></i> Email Address
              </label>
              <div class="input-wrapper">
                <input
                  id="email"
                  type="email"
                  class="form-input"
                  v-model="email"
                  placeholder="Enter your email"
                  @keyup.enter="signIn"
                  autocomplete="email"
                />
              </div>
            </div>

            <div class="form-group">
              <label for="password" class="form-label">
                <i class="fa fa-lock"></i> Password
              </label>
              <div class="input-wrapper">
                <input
                  id="password"
                  type="password"
                  class="form-input"
                  v-model="password"
                  placeholder="Enter your password"
                  @keyup.enter="signIn"
                  autocomplete="current-password"
                />
              </div>
            </div>

            <div v-if="errorMessage" class="error-message">
              <i class="fa fa-exclamation-circle"></i>
              {{ errorMessage }}
            </div>

            <b-button
              class="login-button"
              @click="signIn"
              :disabled="!email || !password"
            >
              <i class="fa fa-sign-in"></i> Sign In
            </b-button>

            <div class="login-help">
              <p class="help-text">
                <i class="fa fa-info-circle"></i>
                Need help? Contact your system administrator
              </p>
            </div>
          </div>
        </div>

        <!-- Footer Section -->
        <div class="login-footer">
          <a href="https://www.newcare.international" target="_blank" class="branding-link">
            Built with <i class="fa fa-heart"></i> by Newcare International
            <span class="company-badge">(an IOIHAN company)</span>
          </a>
        </div>
      </div>
    </div>

    <!-- Location Selection Mode - Full Screen -->
    <div v-if="domains.length > 0" class="location-selection-fullscreen">
      <!-- Header Bar -->
      <div class="fullscreen-header">
        <div class="header-left">
          <img src="@/assets/iPosCafe-Logo.png" class="header-logo" alt="iPOS Cafe by Newcare International" />
          <div class="header-info">
            <h2 class="page-title">Choose Your Location</h2>
            <p class="location-count">{{ domains.length }} location{{ domains.length === 1 ? '' : 's' }} available</p>
          </div>
        </div>
        <div class="header-right">
          <b-button
            @click="signinCancel()"
            variant="outline-secondary"
            class="back-button"
          >
            <i class="fa fa-arrow-left"></i> Back to Login
          </b-button>
        </div>
      </div>

      <!-- Tenant Grid - Full Width -->
      <div class="fullscreen-grid-container">
        <div class="fullscreen-grid">
          <tenant-card 
            v-for="domain in domains" 
            :key="domain.name" 
            :domain="domain" 
            @selectDomain="domainClick"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Authentication from '@/services/AuthenticationService'
import TenantCard     from "@/components/TenantCard.vue";

export default {
  name      : 'login',
  components: {
    TenantCard
  },
  data() {
    return {
      haveToken   : true,
      email       : "",
      password    : "",
      errorMessage: "",
      domain      : "",
      domains     : [],
    }
  },
  async mounted() {
    // if we have a token, verify it to be valid - if valid, then replace the one we have
    // with the new one we just got back and skip the login questions
    // then if/when we get the new token, replace it
    let token = this.getAccessToken();
    if(token) {
      try {
        this.setAccessToken(token); // also sets up axios
        let response = await Authentication.authorize();
        if(response.status === 200) {
          let token = response.data[ 'x-access-token' ];
          this.setAccessToken(token);
          if(await this.$root.getPosConfig()) {
            return this.home();
          }
        } else {
          this.errorMessage = response.data.message;                // oops, the token ain't no good -- let's drop the user at login to start over.
          this.removeAccessToken();
        }
      } catch(error) {
        console.log(error);
        this.errorMessage = "mounted: " + error.message
      }
    }

    this.haveToken = false;

  },
  methods: {
    // this is our "home" screen
    home() {
      this.$router.push({name: 'homeMenu'});
    },
    signinCancel() {
      this.domains      = [];
      this.domain       = "";
      this.errorMessage = "";
    },
    domainClick(domain) {
      this.errorMessage = "";
      this.domain       = domain;
      this.signIn();
    },
    getAccessToken() {
      let token = localStorage.getItem('x-access-token');
      return token;
    },
    setAccessToken(token) {
      localStorage.setItem('x-access-token', token);
    },
    removeAccessToken() {
      localStorage.removeItem('x-access-token');
    },
    async signIn() {

      if(this.email.length === 0 || this.password.length === 0) {
        this.errorMessage = "Please enter email and password"
        return
      }

      let credentials = {
        'email'   : this.email,
        'password': this.password,
        'domain'  : this.domain
      }

      try {
        let response = await Authentication.login(credentials)

        if(response.status == 203) {
          this.removeAccessToken();
          this.domains = response.data;
          return
        }

        if(response.status === 200) {

          let userData = response.data;
          let token    = userData[ 'x-access-token' ];

          this.$root.login( userData );

        } else {
          this.removeAccessToken();
          await this.$root.alert( response.data.message || "Unable to log in", "error");
        }

      } catch(err) {
        await this.$root.alert( err.message || "Unable to log in", "error");
      }

    }
  }
}
</script>

<style lang="scss" scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
  overflow-y: auto;
}

.login-container .login-card {
  background: white;
  border-radius: 1em;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.4);
  max-width: 540px;
  width: 100%;
  overflow: hidden;
  animation: slideIn 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-header {
  text-align: center;
  padding: 20px 30px;
  background: linear-gradient(to bottom, #f8f9fa 0%, #ffffff 100%);
  border-bottom: 1px solid #e9ecef;
}

.login-logo {
  max-width: 360px;
  height: auto;
  margin-bottom: 15px;
  border-radius: 8px;
}

.app-title {
  color: #2c3e50;
  font-size: 32px;
  font-weight: 700;
  margin: 10px 0 5px;
  letter-spacing: -0.5px;
}

.welcome-subtitle {
  color: #6c757d;
  font-size: 14px;
  margin: 0;
  font-weight: 500;
}

.login-body {
  padding: 30px 30px 25px;
}

.login-title {
  color: #2c3e50;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 8px;
  text-align: center;
}

.login-subtitle {
  color: #6c757d;
  font-size: 14px;
  text-align: center;
  margin-bottom: 30px;
  line-height: 1.5;
}

.login-form {
  .form-group {
    margin-bottom: 24px;
  }

  .form-label {
    display: block;
    color: #495057;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 8px;

    i {
      color: #667eea;
      margin-right: 6px;
    }
  }

  .input-wrapper {
    position: relative;
  }

  .form-input {
    width: 100%;
    padding: 12px 16px;
    border: 2px solid #e9ecef;
    border-radius: 8px;
    font-size: 15px;
    transition: all 0.3s ease;
    background: #f8f9fa;

    &:focus {
      outline: none;
      border-color: #667eea;
      background: white;
      box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
    }

    &::placeholder {
      color: #adb5bd;
    }
  }
}

.error-message {
  background: #fff3cd;
  border-left: 4px solid #ffc107;
  color: #856404;
  padding: 12px 16px;
  border-radius: 4px;
  margin-bottom: 20px;
  font-size: 14px;
  display: flex;
  align-items: center;
  animation: shake 0.5s ease;

  i {
    margin-right: 8px;
    font-size: 16px;
  }
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-10px); }
  75% { transform: translateX(10px); }
}

.login-button {
  width: 100%;
  padding: 14px 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 8px;
  color: white;
  font-size: 16px;
  font-weight: 600;
  transition: all 0.3s ease;
  margin-bottom: 20px;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    background: #adb5bd;
  }

  i {
    margin-right: 8px;
  }
}

.login-help {
  text-align: center;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e9ecef;

  .help-text {
    color: #6c757d;
    font-size: 13px;
    margin: 0;

    i {
      color: #667eea;
      margin-right: 6px;
    }
  }
}

// Location Selection Styles
.location-selection {
  .selection-header {
    text-align: center;
    margin-bottom: 24px;
    position: relative;
    
    &::before {
      content: '';
      position: absolute;
      top: -12px;
      left: 50%;
      transform: translateX(-50%);
      width: 40px;
      height: 3px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-radius: 2px;
    }
  }

  .selection-title {
    color: #2c3e50;
    font-size: 22px;
    font-weight: 700;
    margin-bottom: 8px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    letter-spacing: -0.3px;
  }

  .selection-subtitle {
    color: #6c757d;
    font-size: 14px;
    line-height: 1.4;
    font-weight: 500;
    margin: 0 0 12px 0;
  }

  .location-count {
    color: #667eea;
    font-size: 13px;
    font-weight: 600;
    margin: 0;
  }

  .location-grid-container {
    background: #f8f9fa;
    border-radius: 12px;
    border: 1px solid #e9ecef;
    padding: 1em;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(135deg, rgba(102, 126, 234, 0.02) 0%, rgba(118, 75, 162, 0.02) 100%);
      pointer-events: none;
    }
  }

  .location-grid {
    display: grid;
    gap: 16px;
    padding: 4px;

    // Default: Mobile-first approach
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));

    // Custom scrollbar styling (only if needed)
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-radius: 4px;

      &:hover {
        background: linear-gradient(135deg, #5568d3 0%, #6a4190 100%);
      }
    }

    &::-webkit-scrollbar-corner {
      background: #f1f1f1;
    }
  }

  .location-tile {
    background: white;
    border-radius: 16px;
    border: 2px solid #e9ecef;
    cursor: pointer;
    transition: all 0.3s ease;
    overflow: hidden;
    position: relative;
    min-height: 140px;
    display: flex;
    flex-direction: column;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

    &:hover {
      border-color: #667eea;
      transform: translateY(-4px) rotateZ(-2deg);
      box-shadow: 
        0 12px 32px rgba(102, 126, 234, 0.2),
        0 6px 16px rgba(0, 0, 0, 0.1);

      .tenant-logo {
        transform: scale(1.05);
      }

      .logo-fallback {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: white;
        transform: scale(1.05);
      }

      .tenant-name {
        color: #667eea;
        text-shadow: -2px 3px 6px rgba(163,163,163,0.4);
      }

      .tenant-domain {
        color: #764ba2;
      }
    }

    &:active {
      transform: translateY(-2px) rotateZ(-1deg);
    }
  }

  .tile-logo {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px;
    background: white;
    min-height: 85px;
  }

  .tenant-logo {
    max-width: 90%;
    max-height: 90%;
    object-fit: scale-down;
    transition: all 0.3s ease;
  }

  .logo-fallback {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #6c757d;
    color: white;
    font-size: 30px;
    border-radius: 12px;
    transition: all 0.3s ease;
  }

  .tile-content {
    padding: 8px 12px 12px 12px;
    text-align: center;
    background: white;
    border-top: 1px solid #f1f1f1;
  }

  .tenant-name {
    font-size: 14px;
    font-weight: 600;
    color: #2c3e50;
    margin: 0 0 4px 0;
    line-height: 1.2;
    transition: all 0.3s ease;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-word;
    text-shadow: -2px 3px 6px rgba(163,163,163,0.3);
  }

  .tenant-domain {
    font-size: 11px;
    color: #999;
    margin: 0;
    line-height: 1.2;
    transition: all 0.3s ease;
    font-weight: 500;
    font-style: italic;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-top: 1px solid lightgray;
    padding-top: 2px;
  }

  .selection-actions {
    text-align: center;
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid rgba(102, 126, 234, 0.1);
  }

  .cancel-button {
    border-radius: 8px;
    padding: 10px 24px;
    font-weight: 600;
    font-size: 14px;
    transition: all 0.2s ease;
    border: 2px solid #e9ecef;
    color: #6c757d;
    background: white;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      border-color: #667eea;
      color: #667eea;
      background: rgba(102, 126, 234, 0.05);
    }

    &:active {
      transform: translateY(0);
    }

    i {
      margin-right: 6px;
    }
  }
}

// Responsive Design - Maximize Real Estate Usage
@media (max-width: 480px) {
  // iPhone - Single column
  .login-card {
    max-width: 100%;
    margin: 8px;
  }

  .location-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
}

@media (min-width: 481px) and (max-width: 767px) {
  // Small tablets - Two columns
  .login-card {
    max-width: 100%;
    margin: 12px;
  }

  .location-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 14px;
  }
}

@media (min-width: 768px) and (max-width: 1199px) {
  // iPad and small desktops - Three columns
  .location-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
  }
}

@media (min-width: 1200px) and (max-width: 1599px) {
  // Desktop screens - Four columns, larger container
  .location-grid {
    grid-template-columns: repeat(4, 1fr);
    gap: 18px;
  }
}

@media (min-width: 1600px) and (max-width: 1919px) {
  // Large desktops - Five columns
  .location-grid {
    grid-template-columns: repeat(5, 1fr);
    gap: 20px;
  }
}

@media (min-width: 1920px) and (max-width: 2559px) {
  // 1920x1080 and similar - Six columns
  .location-grid {
    grid-template-columns: repeat(6, 1fr);
    gap: 22px;
  }
}

@media (min-width: 2560px) {
  // 4K and ultra-wide displays - Seven or more columns
  .location-grid {
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 24px;
  }
}

// Touch-friendly improvements
@media (pointer: coarse) {
  .location-tile {
    &:hover {
      // Reduce rotation on touch devices
      transform: translateY(-4px);
    }
  }
}

.login-footer {
  background: #f8f9fa;
  padding: 20px 40px;
  text-align: center;
  border-top: 1px solid #e9ecef;
}

.branding-link {
  color: #6c757d;
  font-size: 14px;
  text-decoration: none;
  transition: color 0.3s ease;

  &:hover {
    color: #495057;
    text-decoration: none;
  }

  i.fa-heart {
    color: #e74c3c;
    margin: 0 4px;
    animation: heartbeat 1.5s ease-in-out infinite;
  }
}

@keyframes heartbeat {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

.company-badge {
  display: block;
  font-size: 12px;
  color: #adb5bd;
  margin-top: 4px;
}

// Loading state (optional enhancement)
.login-card.loading {
  pointer-events: none;
  opacity: 0.7;
}

/* ==========================================================================
   FULL-SCREEN LOCATION SELECTION
   ========================================================================== */

.location-selection-fullscreen {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  display: flex;
  flex-direction: column;
}

.fullscreen-header {
  background: white;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
  padding: 20px 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 100;
  border-bottom: 3px solid #667eea;

  @media (max-width: 768px) {
    padding: 16px 20px;
    flex-direction: column;
    gap: 16px;
  }
}

.header-left {
  display: flex;
  align-items: center;
  gap: 24px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
    text-align: center;
  }
}

.header-logo {
  max-width: 200px;
  height: auto;
  border-radius: 8px;

  @media (max-width: 768px) {
    max-width: 160px;
  }
}

.header-info {
  .page-title {
    color: #2c3e50;
    font-size: 2rem;
    font-weight: 700;
    margin: 0 0 4px 0;
    letter-spacing: -0.5px;

    @media (max-width: 768px) {
      font-size: 1.5rem;
    }
  }

  .location-count {
    color: #667eea;
    font-size: 1rem;
    font-weight: 500;
    margin: 0;

    @media (max-width: 768px) {
      font-size: 0.9rem;
    }
  }
}

.header-right {
  .back-button {
    padding: 12px 24px;
    font-weight: 600;
    border-radius: 8px;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }

    @media (max-width: 768px) {
      padding: 10px 20px;
      font-size: 0.9rem;
    }
  }
}

.fullscreen-grid-container {
  flex: 1;
  padding: 40px;
  overflow-x: hidden;

  @media (max-width: 768px) {
    padding: 20px 16px;
  }

  @media (max-width: 480px) {
    padding: 16px 12px;
  }
}

.fullscreen-grid {
  display: grid;
  gap: 24px;
  max-width: 1600px;
  margin: 0 auto;

  // Responsive grid that maximizes real estate
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  @media (min-width: 481px) and (max-width: 767px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 18px;
  }

  @media (min-width: 768px) and (max-width: 1199px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }

  @media (min-width: 1200px) and (max-width: 1599px) {
    grid-template-columns: repeat(4, 1fr);
    gap: 22px;
  }

  @media (min-width: 1600px) and (max-width: 1919px) {
    grid-template-columns: repeat(5, 1fr);
    gap: 24px;
  }

  @media (min-width: 1920px) and (max-width: 2559px) {
    grid-template-columns: repeat(6, 1fr);
    gap: 26px;
  }

  @media (min-width: 2560px) {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 28px;
    max-width: 2400px;
  }
}

// Animation for full-screen mode
.location-selection-fullscreen {
  animation: fullscreenFadeIn 0.6s ease-out;
}

@keyframes fullscreenFadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>



